import { render, staticRenderFns } from "./cubeSpin.vue?vue&type=template&id=73629c84&scoped=true&"
import script from "./cubeSpin.vue?vue&type=script&lang=js&"
export * from "./cubeSpin.vue?vue&type=script&lang=js&"
import style0 from "./cubeSpin.vue?vue&type=style&index=0&id=73629c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73629c84",
  null
  
)

export default component.exports